<!--
    관리자 페이지
    작성자: 박찬양
-->
<template>
    <v-card>
        <v-tabs v-model="tab" grow icons-and-text>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1" :ripple="false" class="admin-tab">
                <span>계정 관리</span>
                <v-icon>mdi-account-plus</v-icon>
            </v-tab>

            <!-- <v-tab href="#tab-2" disabled>
                <span>비활성화</span>
                <v-icon>mdi-alert</v-icon>
            </v-tab>

            <v-tab href="#tab-3" disabled>
                <span>비활성화</span>
                <v-icon>mdi-alert</v-icon>
            </v-tab> -->
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
                <v-container>
                    <v-card>
                        <v-card-title>
                            <v-row>
                                <v-col sm="12" xs="6" md="6">
                                    <v-btn @click="(dialogStatus.isRegister = true, userRegisterDialog = true)"
                                        color="primary" class="mr-4">
                                        계정 등록
                                    </v-btn>
                                </v-col>
                                <v-col sm="6" xs="12" md="3">
                                    <v-select v-model="selectedFilterCondition" :items="filterCondition" hide-details
                                        outlined dense></v-select>
                                </v-col>
                                <v-col sm="6" xs="12" md="3">
                                    <v-text-field outlined dense v-model="search" append-icon="mdi-magnify" label="검색"
                                        single-line hide-details></v-text-field>
                                </v-col>
                            </v-row>

                            <!-- <v-spacer /> -->


                        </v-card-title>
                        <v-data-table class="table-list" :page.sync="page" :items-per-page="itemsPerPage"
                            @page-count="pageCount = $event" @click:row="openUserInfo" hide-default-footer
                            no-results-text="검색 결과 없음" no-data-text="조회 결과 없음" :items="filterdUserList" :headers="headers"
                            :search="search">
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination v-model="page" :length="pageCount" />
                            <v-text-field v-show="false" :value="itemsPerPage" label="" type="number" min="-1" max="15"
                                @input="itemsPerPage = parseInt($event, 10)" />
                        </div>
                    </v-card>
                </v-container>

            </v-tab-item>
        </v-tabs-items>

        <!-- 등록 OR 편집 폼 -->
        <template>
            <v-dialog persistent v-model="userRegisterDialog" width="50%" :fullscreen="isMobile ? true : false">
                <v-card>
                    <v-card-title>
                        <span v-if="dialogStatus.isRegister === true" class="dialogTitle" style="font-size: large;">계정
                            등록</span>
                        <span v-else-if="dialogStatus.isUpdate === true" class="dialogTitle" style="font-size: large;">계정
                            편집</span>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>

                        <v-form ref="observer" v-model="valid">

                            <v-checkbox :hide-details="true" v-if="dialogStatus.isUpdate === true" v-model="userData.isUse"
                                label="계정활성화"></v-checkbox>

                            <v-text-field v-model="userData.id" single-line :rules="[idRules]" label="아이디" required
                                :readonly="dialogStatus.isUpdate === true" maxlength="20" counter="20">
                                <template v-slot:append-outer v-if="dialogStatus.isRegister === true">
                                    <v-btn :disabled="isCheckDuplicateUserIDDisabled" color="success" small
                                        @click="checkDuplicate()">중복체크</v-btn>
                                </template>
                            </v-text-field>

                            <v-text-field v-model="userData.name" maxlength="100" counter="100" single-line :rules="nameRules" label="이름"
                                required></v-text-field>

                            <v-text-field v-model="userData.email" maxlength="100" counter="100" single-line :rules="[emailRules]" label="이메일"
                                required></v-text-field>

                            <v-text-field v-model="userData.mobileNum" maxlength="13" counter="13" single-line label="전화번호"
                                required></v-text-field>

                            <v-text-field v-model="userData.projectName" maxlength="50" counter="50" single-line label="프로젝트 이름"
                                required></v-text-field>

                            <v-select v-model="userData.role" :items="roles"></v-select>

                            <v-text-field v-model="userData.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[passwordRules]" :single-line="true" maxlength="15"
                                :type="show1 ? 'text' : 'password'" name="input-10-1" label="비밀번호" counter
                                @click:append="show1 = !show1"></v-text-field>

                            <v-text-field v-model="userData.confirmPassword" :rules="[matchingPasswords]"
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                                name="input-10-1" label="비밀번호 확인" counter :single-line="true" maxlength="15"
                                @click:append="show2 = !show2"></v-text-field>
                        </v-form>

                    </v-card-text>
                    <v-card-text class="pt-10">

                        <v-btn large @click="userRegisterDialog = false" absolute bottom left>취소</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="dialogStatus.isRegister === true" large
                            :disabled="valid === false || isCheckDuplicateUserID == false" absolute bottom right
                            color="success" class="mr-4 float-end" @click="userJoinInfo()">
                            등록
                        </v-btn>
                        <v-btn v-else-if="dialogStatus.isUpdate === true" :disabled="valid === false || isDataEqual === true" large absolute bottom
                            right color="success" class="mr-4 float-end" @click="updateUser()">
                            저장
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog persistent v-model="userRegisterCompleteDialog" :width="isMobile ? '60%' : '20%'">
                <v-card>
                    <v-card-title v-if="dialogStatus.isRegister === true">
                        계정 생성 완료
                    </v-card-title>
                    <v-card-title v-else-if="dialogStatus.isUpdate === true">
                        계정 편집 완료
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="py-3" v-if="dialogStatus.isRegister === true" style="color: #333333;">
                        계정 생성이 완료되었습니다.
                    </v-card-text>
                    <v-card-text class="py-3" v-if="dialogStatus.isUpdate === true" style="color: #333333;">
                        계정 편집이 완료되었습니다.
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end pb-4 pt-1">
                        <v-btn class="float-end" color="success" @click="userRegisterComplete">확인</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog persistent v-model="isCheckDuplicateUserIDDialog" :width="isMobile ? '60%' : '20%'">
                <v-card>
                    <v-card-title>
                        아이디 중복 체크
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="py-3">
                        <p class="mb-0" style="color: #333333;">{{ checkDuplicateByUserIDMessage }}</p>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end pb-4 pt-1">
                        <v-btn class="float-end" color="success" @click="isCheckDuplicateUserIDDialog = false">확인</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-card>
</template>

<script>
import { call, sync } from 'vuex-pathify'
import DataUtilss from '../util/data'
import _ from 'lodash'
export default {
    name: 'DefaultAccount',

    data: () => ({
        menu: false,
        tab: null,
        valid: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 15,
        userData: {
            name: '',
            id: '',
            email: '',
            mobileNum: '',
            projectName: '',
            role: 'ROLE_USER',
            password: '',
            confirmPassword: '',
            isUse: false
        },
        copyUserData: {},
        isDataEqual: true,
        userDataisEqual: true,

        nameRules: [
            v => !!v || '필수 입력 사항입니다.'
        ],
        email: '',
        // passwordRules: [
        //     v => !!v || '필수 입력 사항입니다.',
        // ],
        checkbox: false,
        show1: false,
        show2: false,
        search: '',
        checkDuplicateByUserIDRegExp: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/,
        checkKoreanRegExp: /[ㄱ-ㅎㅏ-ㅣ가-힣]+/,
        checkDuplicateByUserIDMessage: '',
        isCheckDuplicateUserIDDisabled: true,
        isCheckDuplicateUserID: false,
        isCheckDuplicateUserIDDialog: false,
        userRegisterCompleteDialog: false,
        userRegisterDialog: false,
        dialogStatus: {
            isRegister: false,
            isUpdate: false
        },
        selectedFilterCondition: '',
        filterCondition: [
            {
                text: '계정 상태 : 전체',
                value: ''
            },
            {
                text: '계정 상태 : 활성화',
                value: '활성화'
            },
            {
                text: '계정 상태 : 비활성화',
                value: '비활성화'
            }
        ],
        roles: [
            {
                text: '일반 사용자',
                value: 'ROLE_USER'
            },
            {
                text: '관리자',
                value: 'ROLE_ADMIN'
            }
        ],

        headers: [
            {
                text: '아이디',
                align: 'center',
                sortable: true,
                value: 'userId',
            },
            {
                text: '이름',
                align: 'center',
                sortable: true,
                value: 'username',
            },
            {
                text: '전화번호',
                align: 'center',
                sortable: true,
                value: 'mobile',
            },
            {
                text: '이메일',
                align: 'center',
                sortable: true,
                value: 'email',
            }
            ,
            {
                text: '권한',
                align: 'center',
                sortable: true,
                value: 'roleText',
            }
            ,
            {
                text: '프로젝트 이름',
                align: 'center',
                sortable: true,
                value: 'projectName',
            },
            {
                text: '계정 상태',
                align: 'center',
                sortable: true,
                value: 'status',
            },
        ]
    }),
    computed: {
        userList: sync('admin/userList'),

        isMobile: function () {
            return DataUtilss.isMobile()
        },

        ...sync('account', [
            'userInfo',
            'fcmKey',
            'usePush',
            'useNightPush',
        ]),

        filterdUserList: function () {
            if (this.selectedFilterCondition === '') {
                return this.userList
            } else if (this.selectedFilterCondition === '활성화') {
                return this.userList.filter(element => element.use === true)
            } else if (this.selectedFilterCondition === '비활성화') {
                return this.userList.filter(element => element.use === false)
            }
        }
    },

    watch: {
        userRegisterDialog: function () {
            if (this.userRegisterDialog === false) {
                this.userData.name = ''
                this.userData.id = ''
                this.userData.email = ''
                this.userData.mobileNum = ''
                this.userData.projectName = ''
                this.userData.password = ''
                this.userData.confirmPassword = ''
                this.userData.role = 'ROLE_USER'
                this.userData.isUse = 1
                this.isUse = false
                this.show1 = false
                this.show2 = false
                this.dialogStatus.isRegister = false
                this.dialogStatus.isUpdate = false
            }
        },

        userData: {
            handler(newValue, oldValue) {
                if (this.dialogStatus.isUpdate === true) {
                    if (!_.isEqual(newValue, this.copyUserData)) {
                        this.isDataEqual = false
                    } else {
                        this.isDataEqual = true
                    }
                }
            },
            deep: true
    },

    'userData.id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.isCheckDuplicateUserID = false
        }
    },

    'userData.password': function (newVal, oldVal) {
        if (this.dialogStatus.isUpdate === true) {
            if (newVal !== oldVal) {
                if (this.validate() !== undefined) {
                    this.validate()
                }
            }
            if (newVal === '') {
                this.userData.password = null
            }
        }
    },

    'userData.confirmPassword': function (newVal, oldVal) {
        if (this.dialogStatus.isUpdate === true) {
            if (newVal === '') {
                this.userData.confirmPassword = null
            }
        }
    }
},

created() {
    this.fetchUserList()
},

methods: {
    openUserInfo(item) {
        this.userData = {
            id: item.userId,
            name: item.username,
            email: item.email,
            mobileNum: item.mobile,
            projectName: item.projectName,
            password: item.userPassword,
            confirmPassword: item.userPassword,
            isUse: item.use,
            role: item.role
        }

        this.copyUserData = {
            id: item.userId,
            name: item.username,
            email: item.email,
            mobileNum: item.mobile,
            projectName: item.projectName,
            password: item.userPassword,
            confirmPassword: item.userPassword,
            isUse: item.use,
            role: item.role
        }
        this.dialogStatus.isUpdate = true
        this.userRegisterDialog = true
    },

    validate() {
        if (this.$refs.observer !== undefined)  {
            this.$refs.observer.validate()
        }
    },

    postUserJoin: call('admin/postUserJoin'),

        userJoinInfo() {
        this.validate()

        if (this.valid === true && this.isCheckDuplicateUserID === true) {
            if (this.userData.isUse === true) {
                this.userData.isUse = 1
            } else {
                this.userData.isUse = 0
            }
            this.postUserJoin(this.userData)
                .then((response) => {
                    this.fetchUserList()
                    this.userRegisterCompleteDialog = true
                })
        }
    },

    postUpdateUserByAdmin: call('admin/postUpdateUserByAdmin'),

        updateUser() {
        this.validate()
        if (this.userData.password === '' || this.userData.password === null) {
            this.valid = true
        }
        if (this.valid === true) {
            if (this.userData.isUse === true) {
                this.userData.isUse = 1
            } else {
                this.userData.isUse = 0
            }
            this.postUpdateUserByAdmin(this.userData)
                .then((response) => {
                    if (response.data === 1) {
                        this.userRegisterCompleteDialog = true
                    }
                    this.fetchUserList()
                })
        }
    },

    userRegisterComplete() {
        this.isCheckDuplicateUserID = false
        this.userRegisterCompleteDialog = false
        let isUpdatingMyID = false // 본인 아이이디를 업데이트 한 경우

        if (this.userInfo.userId === this.userData.id) {
            isUpdatingMyID = true
        }
        this.userRegisterDialog = false
        if (isUpdatingMyID === true) {
            this.goLogin()
        }
    },

    idRules(value) {
        if (this.isCheckDuplicateUserID === true) {
            return true
        }
        if (value === undefined || value === '') {
            this.isCheckDuplicateUserIDDisabled = true
            return '필수 입력 사항입니다.'
        } else if (this.checkDuplicateByUserIDRegExp.test(value)) {
            this.isCheckDuplicateUserIDDisabled = true
            return '특수 문자는 허용되지 않습니다.'
        } else if (this.checkKoreanRegExp.test(value)) {
            this.isCheckDuplicateUserIDDisabled = true
            return '한글은 허용되지 않습니다.'
        } else if (value.includes(' ')) {
            this.isCheckDuplicateUserIDDisabled = true
            return '공백은 허용되지 않습니다.'
        } else if (this.isCheckDuplicateUserID === false) {
            if (this.dialogStatus.isUpdate === true) {
                return true
            } else {
                this.isCheckDuplicateUserIDDisabled = false
                return '아이디 중복체크는 필수입니다.'
            }
        } else {
            this.isCheckDuplicateUserIDDisabled = false
            return true
        }
    },

    passwordRules(value) {
        if (this.dialogStatus.isUpdate === true) {
            return true
        } else {
            if (value === undefined || value === '' || value === null) {
                return '필수 입력 사항입니다.'
            } else {
                return true
            }
        }
    },

    matchingPasswords(value) {
        if (this.dialogStatus.isUpdate === true && (this.userData.password === '' || this.userData.password === null)) {
            return true
        } else if (this.dialogStatus.isUpdate === true && (this.userData.password !== '' || this.userData.password !== null)) {
            if (value === this.userData.password) {
                return true
            } else {
                return '비밀번호가 일치하지 않습니다.'
            }
        }
        if (value === undefined || value === '' || value === null) {
            return '필수 입력 사항입니다.'
        } else if (this.userData.password !== value) {
            return '비밀번호가 일치하지 않습니다.'
        } else {
            return true
        }
    },

    goLogin() {
        this.menu = false
        this.userInfo = {
            token: null,
            msg: null,
            role: null,
            expired: true,
            userId: null,
            userName: null,
        }
        this.fcmKey = null
        this.usePush = false
        this.useNightPush = false
        this.$router.replace({ name: 'Login' })
    },

    emailRules(value) {
        if (value !== null && value !== '' && !/.+@.+\..+/.test(value)) {
            return '이메일 형식이 아닙니다.'
        } else {
            return true
        }
    },

    checkDuplicateRule() {
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(this.userData.id)) {
            return false
        } else {
            return true
        }
    },

    checkDuplicate() {
        let params = {
            id: this.userData.id
        }
        this.checkDuplicateByUserID(params)
            .then((response) => {
                if (this.userData.id === response.data.userId) {
                    this.checkDuplicateByUserIDMessage = '중복된 아이디입니다.'
                    this.isCheckDuplicateUserID = false
                } else {
                    this.checkDuplicateByUserIDMessage = '사용가능한 아이디입니다.'
                    this.isCheckDuplicateUserID = true
                    this.validate()
                }
                this.isCheckDuplicateUserIDDialog = true
            })
    },

    checkDuplicateByUserID: call('admin/checkDuplicateByUserID'),

        fetchUserList: call('admin/fetchUserList')
},
}
</script>

<style lang="scss" scoped>
.dialogTitle {
    font-size: 1rem !important;
}

.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab--active::before {
    opacity: 0;
}

.admin-tab {
    cursor: default !important;
    /* 마우스 커서를 기본값으로 변경 */
}

.table-list {
    cursor: pointer !important;
}
</style>
